module.exports = __webpack_public_path__ + "img/oops.ae7ce479.png";